// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-footer-white-label {
    background: var(--clr-white);
    border-top: 1px dotted var(--clr-grey-3);
    padding: 20px 16px;
    font-size: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .footer-content-white-label {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 24px;
    justify-content: center;
    text-align: center;
  }
  
  /* "Scheduling by" + logo */
  .footer-branding-white-label {
    display: flex;
    align-items: center;
    gap: 10px;
    font-weight: 600;
    font-size: 1rem;
    color: var(--clr-grey-5);
    cursor: pointer;
  }
  
  .footer-logo-white-label {
    height: 84px; 
    width: auto;
    object-fit: contain;
    border: 1.5px solid var(--clr-primary-4); 
    border-radius: 8px; 
    padding: 4px 6px; 
    background-color: #fff;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }
  
  .footer-logo-white-label:hover {
    transform: scale(1.05);
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);
  }
  
  
  /* Links (Terms, Practice Here) */
  .footer-link {
    color: var(--clr-accent);
    font-weight: 500;
    cursor: pointer;
    transition: color 0.3s ease;
  }
  
  .footer-link:hover {
    color: var(--clr-primary-5);
  }
  
  /* Separator styling */
.footer-separator {
    color: var(--clr-grey-4);
    font-weight: 400;
    font-size: 1.2rem;
    -webkit-user-select: none;
            user-select: none;
  }
  
  /* Hide separator on mobile for vertical stack */
  @media (max-width: 600px) {
    .footer-separator {
      display: none;
    }
  }
  
  /* ------------------------ */
  /* 📱 Mobile (max-width: 600px) */
  @media (max-width: 600px) {
    .footer-content-white-label {
      flex-direction: column;
      gap: 16px;
    }
  
    .footer-branding-white-label {
      flex-direction: column;
      gap: 6px;
      font-size: 0.95rem;
    }
  
    .footer-logo-white-label {
      height: 40px;
    }
  
    .footer-link {
      font-size: 0.95rem;
    }
  }
  
  /* 🧾 Tablet (601px–991px) */
  @media (min-width: 601px) and (max-width: 991px) {
    .footer-content-white-label {
      flex-wrap: wrap;
      gap: 20px;
    }
  
    .footer-logo-white-label {
      height: 42px;
    }
  
    .footer-link {
      font-size: 1rem;
    }
  }
  
  /* 🖥️ Desktop (992px+) */
  @media (min-width: 992px) {
    .footer-content-white-label {
      flex-direction: row;
      gap: 32px;
    }
  
    .footer-logo-white-label {
      height: 75px;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/footer/WhiteLabelFooter.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;IAC5B,wCAAwC;IACxC,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,SAAS;IACT,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA,2BAA2B;EAC3B;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,eAAe;IACf,wBAAwB;IACxB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,qDAAqD;EACvD;;EAEA;IACE,sBAAsB;IACtB,yCAAyC;EAC3C;;;EAGA,iCAAiC;EACjC;IACE,wBAAwB;IACxB,gBAAgB;IAChB,eAAe;IACf,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA,sBAAsB;AACxB;IACI,wBAAwB;IACxB,gBAAgB;IAChB,iBAAiB;IACjB,yBAAiB;YAAjB,iBAAiB;EACnB;;EAEA,gDAAgD;EAChD;IACE;MACE,aAAa;IACf;EACF;;EAEA,6BAA6B;EAC7B,iCAAiC;EACjC;IACE;MACE,sBAAsB;MACtB,SAAS;IACX;;IAEA;MACE,sBAAsB;MACtB,QAAQ;MACR,kBAAkB;IACpB;;IAEA;MACE,YAAY;IACd;;IAEA;MACE,kBAAkB;IACpB;EACF;;EAEA,4BAA4B;EAC5B;IACE;MACE,eAAe;MACf,SAAS;IACX;;IAEA;MACE,YAAY;IACd;;IAEA;MACE,eAAe;IACjB;EACF;;EAEA,yBAAyB;EACzB;IACE;MACE,mBAAmB;MACnB,SAAS;IACX;;IAEA;MACE,YAAY;IACd;EACF","sourcesContent":[".custom-footer-white-label {\n    background: var(--clr-white);\n    border-top: 1px dotted var(--clr-grey-3);\n    padding: 20px 16px;\n    font-size: 1rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  .footer-content-white-label {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 24px;\n    justify-content: center;\n    text-align: center;\n  }\n  \n  /* \"Scheduling by\" + logo */\n  .footer-branding-white-label {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    font-weight: 600;\n    font-size: 1rem;\n    color: var(--clr-grey-5);\n    cursor: pointer;\n  }\n  \n  .footer-logo-white-label {\n    height: 84px; \n    width: auto;\n    object-fit: contain;\n    border: 1.5px solid var(--clr-primary-4); \n    border-radius: 8px; \n    padding: 4px 6px; \n    background-color: #fff;\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n  }\n  \n  .footer-logo-white-label:hover {\n    transform: scale(1.05);\n    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);\n  }\n  \n  \n  /* Links (Terms, Practice Here) */\n  .footer-link {\n    color: var(--clr-accent);\n    font-weight: 500;\n    cursor: pointer;\n    transition: color 0.3s ease;\n  }\n  \n  .footer-link:hover {\n    color: var(--clr-primary-5);\n  }\n  \n  /* Separator styling */\n.footer-separator {\n    color: var(--clr-grey-4);\n    font-weight: 400;\n    font-size: 1.2rem;\n    user-select: none;\n  }\n  \n  /* Hide separator on mobile for vertical stack */\n  @media (max-width: 600px) {\n    .footer-separator {\n      display: none;\n    }\n  }\n  \n  /* ------------------------ */\n  /* 📱 Mobile (max-width: 600px) */\n  @media (max-width: 600px) {\n    .footer-content-white-label {\n      flex-direction: column;\n      gap: 16px;\n    }\n  \n    .footer-branding-white-label {\n      flex-direction: column;\n      gap: 6px;\n      font-size: 0.95rem;\n    }\n  \n    .footer-logo-white-label {\n      height: 40px;\n    }\n  \n    .footer-link {\n      font-size: 0.95rem;\n    }\n  }\n  \n  /* 🧾 Tablet (601px–991px) */\n  @media (min-width: 601px) and (max-width: 991px) {\n    .footer-content-white-label {\n      flex-wrap: wrap;\n      gap: 20px;\n    }\n  \n    .footer-logo-white-label {\n      height: 42px;\n    }\n  \n    .footer-link {\n      font-size: 1rem;\n    }\n  }\n  \n  /* 🖥️ Desktop (992px+) */\n  @media (min-width: 992px) {\n    .footer-content-white-label {\n      flex-direction: row;\n      gap: 32px;\n    }\n  \n    .footer-logo-white-label {\n      height: 75px;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
